<template>
    <div>
        <div class="row">
            <list />
        </div>
    </div>
</template>

<script>
import list from '../../components/plannervid/videos/list'

export default {
  name: 'videos',
  components: { list },
}
</script>
